export const environment = {
  production: false,
  apiUrl: 'https://jhsfid-dv-api.jhsf.io',
  zipCodeApiUrl: 'https://viacep.com.br/ws/',
  userProfile: '',
}
